$('.js-tabs').on('click', '.tabs__nav a', function (event) {
  event.preventDefault();

  const $this = $(this);
  const $element = $($($this).attr('href'));

  if (!$element.length) {
    return;
  }

  $element
    .add($this.parent())
    .addClass('current')
    .siblings('.current')
    .removeClass('current');
});
